import axios from "@/api/axiosInstance";
import { ListDiagnosticsResponse } from "./types";
import type { DiagnosticSummary } from "../../types/diagnostic";

/**
 * The published instruments. Gated on the coach permission rather than the
 * authoring one, because this is what the "New Diagnostic" dialog reads.
 */
export const listDiagnostics = async (
  signal?: AbortSignal,
): Promise<DiagnosticSummary[]> => {
  const response = await axios.get<ListDiagnosticsResponse>(
    "/api/private/diagnostics",
    { signal },
  );
  return response.data.data.diagnostics;
};
